import React from 'react'
import styled from 'styled-components'
import Countdown from 'react-countdown-now';

const SpecialCMCardContentStyle = styled.div`
  position: absolute;
  padding: 20px;
  z-index: 99999;
  height: calc(100% - 40px);
  width: calc(100% - 40px);
  display: flex;
  align-content: space-between;
  flex-wrap: wrap;

  .specialCMCardContentTitle {
    h2 {
      color: white;
      margin-bottom: 4px;
    }
  
    h5 {
      color: white;
    }
  }

  .specialCMCardContentExtra {
    display: grid;
    grid-template-columns: 1fr max-content;
    width: 100%;
    justify-content: space-between;
    align-items: center;

    #demo {
      color: white;
    }

    #TagSpecial {
      color: white;
      padding: 8px 12px;
      background-color: #f80b0b;
      border-radius: 7px;
      box-shadow: 0px 5px 20px 5px rgba(45, 45, 45, 0.52)
    }
  }
`;

export default class SpecialCMCardContent extends React.Component {
  render() {
    return (
      <SpecialCMCardContentStyle>
        <div className="specialCMCardContentTitle">
          <h2>Camminando mangiando</h2>
          <h5>10^ Edizione</h5>
        </div>
        <div className="specialCMCardContentExtra">
          <h5 id="demo"></h5>
          {/* <Countdown
            date={new Date("May 12, 2019 08:30:00 GMT+01:00").getTime()}
            intervalDelay={0}
            precision={0}
            zeroPadTime={0}
            renderer={props => <h5 style={{color:'white'}}>{props.days}d {props.hours}h {props.minutes}m {props.seconds}s</h5>}
          /> */}
          <h5 id="TagSpecial">Evento speciale</h5>
        </div>
      </SpecialCMCardContentStyle>
    )
  }
}